/* ==========================================================================
   PanelAccommodation > Client > Validations
   ========================================================================== */

function validateInfo(instance) {
    const { config = {}, store } = instance;
    const { maxRooms = 0, maxPeople = 0, literals = {} } = config;
    const { errorMaxRooms = '#number#', errorMaxPeople = '#number#', infoMaxRooms, infoMaxPeople } = literals;

    const { totalRooms = 0, totalPeople = 0, error, hasInfo } = store.select('data');
    const hasTotalRooms = maxRooms > 0 && totalRooms > maxRooms - 1;
    const hasTotalPeople = maxPeople > 0 && totalPeople > maxPeople - 1;

    const infoMaxRoomsMsg = infoMaxRooms || errorMaxRooms;
    const infoMaxPeopleMsg = infoMaxPeople || errorMaxPeople;

    if (error) return;

    if (hasInfo) {
        instance.actions.removeInfo();
        instance.actions.enableIncrement();
    }

    if (hasTotalRooms) {
        if (hasTotalPeople) instance.actions.disableIncrement();

        if (hasTotalPeople) instance.actions.setInfo(infoMaxPeopleMsg.replace('#number#', maxPeople));
        else instance.actions.setInfo(infoMaxRoomsMsg.replace('#number#', maxRooms));
        return;
    }

    if (hasTotalPeople) {
        instance.actions.setInfo(infoMaxPeopleMsg.replace('#number#', maxPeople));
        instance.actions.disableIncrement();
    }
}

function validateError(instance) {
    const { config = {}, store } = instance;
    const { maxRooms = 0, maxPeople = 0, literals = {} } = config;
    const { errorMaxRooms = '#number#', errorMaxPeople = '#number#' } = literals;

    const { totalRooms = 0, totalPeople = 0, error } = store.select('data');
    const hasTotalRooms = maxRooms > 0 && totalRooms > maxRooms;
    const hasTotalPeople = maxPeople > 0 && totalPeople > maxPeople;

    if (hasTotalRooms) {
        if (hasTotalPeople) instance.actions.disableIncrement();

        instance.actions.setError(errorMaxRooms.replace('#number#', maxRooms));

        return;
    }

    if (hasTotalPeople) {
        instance.actions.setError(errorMaxPeople.replace('#number#', maxPeople));
        instance.actions.disableIncrement();

        return;
    }

    if (error) {
        instance.actions.setValid();
        instance.actions.enableIncrement();
    }
}

function validate(instance) {
    validateError(instance);
    validateInfo(instance);
}

module.exports = {
    validate
};
